import { ScrollingNumber } from '@/components/molecules';
import ChartSection from '@/components/organisms/ChartSection/ChartSection';
import React, { FC, ReactNode } from 'react';
interface ProjectionData {
  value: number;
  time: string;
  label: string;
}
interface Props {
  projectionData: ProjectionData[];
  growthRate: number;
  showGrowthRate?: boolean;
  startAtZero?: boolean;
  className?: string;
  yAxisType?: 'usd' | 'token' | 'percentage';
  tokenTicker?: string;
  xAxisLabels?: string[];
  yAxisLabels?: string[];
  title?: React.ReactNode;
  chartHeight?: number;
  chartMinHeight?: number;
  chartMaxHeight?: number;
  noDataNode?: React.ReactNode;
  chartId: string;
  chartColor?: string;
  extraContent?: ReactNode;
}
const ProjectionChartSection: FC<Props> = ({
  projectionData,
  growthRate,
  showGrowthRate = true,
  startAtZero = false,
  className = '',
  yAxisType = 'usd',
  tokenTicker,
  xAxisLabels,
  yAxisLabels,
  title = 'Projection',
  chartHeight,
  chartMinHeight,
  chartMaxHeight,
  noDataNode,
  chartId,
  chartColor,
  extraContent,
}) => {
  return (
    <ChartSection
      chartingData={projectionData}
      startAtZero={startAtZero}
      className={className}
      yAxisType={yAxisType}
      tokenTicker={tokenTicker}
      xAxisLabels={xAxisLabels}
      yAxisLabels={yAxisLabels}
      title={title}
      headerRightNode={
        showGrowthRate && (
          <ScrollingNumber value={growthRate} suffix={'% APY'} />
        )
      }
      chartHeight={chartHeight}
      chartMinHeight={chartMinHeight}
      chartMaxHeight={chartMaxHeight}
      chartId={chartId}
      chartColor={chartColor}
      extraContent={extraContent}
      noDataNode={noDataNode}
    />
  );
};
export default ProjectionChartSection;
